import React, { useEffect, useState } from 'react';
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { firestore } from '../../lib/firebase';
import Watermark from '../../assets/Watermark.png';
import Header from '../../components/Header';
import { getCookie } from "../../utils/cookieUtil";
import { EyeIcon, EyeOffIcon, InformationCircleIcon } from '@heroicons/react/solid';
import { Tooltip } from 'react-tooltip';
import '@fortawesome/fontawesome-free/css/all.min.css';

const InvitedUserDetails = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uid, setUid] = useState(null);
  const [permission, setPermission] = useState('');
  const [error, setError] = useState(null);
  const [hovered, setHovered] = useState(null); // Added hovered state



  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uidFromParams = params.get('uid');
    if (uidFromParams) {
      setUid(uidFromParams);
    }
  }, []);

  useEffect(() => {
    const roles = getCookie('roleId');
    if (roles) {
      setPermission(`${roles} `);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!uid) return;
      console.log("!!!!!!!!!", uid);

      console.log("Fetching user with UID:", uid); // ✅ Debug

      setLoading(true);
      try {
        const userDoc = await getDoc(doc(firestore, 'UsersList', uid));

        if (!userDoc.exists()) {
          console.warn("User document not found for UID:", uid);
          setError('User not found.');
          return;
        }

        const user = userDoc.data();
        console.log("User data:", user); // ✅ Debug
        setUserDetails({ user });

      } catch (error) {
        console.error('Error fetching user details:', error);
        setError('Failed to fetch user details.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid]);



  const LoadingSpinner = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
    </div>
  );

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="text-red-500">{error}</div>;

  const { user } = userDetails || {};


return (
  <div className="w-full flex items-center justify-center">
    <div className="w-full max-w-xl h-64 mx-4 bg-white/90 rounded-3xl shadow-2xl flex flex-col md:flex-row items-center p-10 gap-8">
      {/* Avatar */}
      <div className="flex-shrink-0">
        <div
          className="bg-red-800 text-white font-bold w-28 h-28 rounded-full flex items-center justify-center text-4xl shadow-lg"
          aria-label="User Initial"
        >
          {user?.firstName?.[0]?.toUpperCase() || 'U'}
        </div>
      </div>
      {/* User Info */}
      <div className="flex-1 flex flex-col justify-center">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
          {user?.firstName} {user?.secondName || ''}
        </h1>
        <p className="text-lg text-gray-700 mb-1">{user?.email}</p>
        <div className="mt-4">
          <span className="inline-block bg-blue-100 text-blue-800 text-sm font-semibold px-4 py-2 rounded-full">
            Group: {user?.group}
          </span>
        </div>
      </div>
    </div>
    {loading && <LoadingSpinner />}
  </div>
);

};

export default InvitedUserDetails;
